import {MdArrowDropUp, MdBarChart, MdOutlineCalendarToday} from 'react-icons/md';
import Card from 'components/card';
import {lineChartOptionsTotalSpent} from 'variables/charts';
import LineChart from 'components/charts/LineChart';
import {AccountSummaryResponse} from '../../../../stores/types';

const getDaysAt = (summary: AccountSummaryResponse, days: number) => {
  for (const txn of summary.periods) {
    if (txn.days === days) {
      return {
        totalCredit: isNaN(txn.totalCredit) ? 0 : txn.totalCredit,
        totalDebit: isNaN(txn.totalDebit) ? 0 : txn.totalDebit,
        creditCount: isNaN(txn.creditCount) ? 0 : txn.creditCount,
        debitCount: isNaN(txn.debitCount) ? 0 : txn.debitCount,
      };
    }
  }

  return {
    totalCredit: 0,
    totalDebit: 0,
    creditCount: 0,
    debitCount: 0,
  };
};


const TotalSpent = (props: {summary: AccountSummaryResponse}) => {

  if (props.summary === null) {
    return <div />;
  }

  const chartData = [
    {
      name: "Credit",
      data: [1, 7, 30, 90].map((d) => getDaysAt(props.summary, d).totalCredit),
      color: "#4318FF",
    },
    {
      name: "Debit",
      data: [1, 7, 30, 90].map((d) => getDaysAt(props.summary, d).totalDebit),
      color: "#6AD2FF",
    },
  ];


  return (
    <Card extra="!p-[20px] text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">Transaction Volumes</h2>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      <div className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="h-full w-full">
          <LineChart
            chartOptions={lineChartOptionsTotalSpent}
            chartData={chartData}
          />
        </div>
      </div>
    </Card>
  );
};

export default TotalSpent;
